import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import { downloadAttachment } from "../../helpers/attachmentUtils";

export const Downloader = ({ file, filename, }) => {

  async function downloadFile() {
    try {
      await downloadAttachment(file, filename);
    } catch (error) {
      console.error("Error downloading the file:", error);
      if (file?.url) {
        const link = document.createElement("a");
        link.href = file.url;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.download = file.filename || filename || "";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
  return (
    <>
      <Button onClick={() => downloadFile()}><DownloadOutlined /></Button>
      {/* <a style={{ display: "none" }} ref={link} href={url} download={filename}>
        Table export
      </a> */}
    </>
  );
};
